import React from "react";
import { Link } from "react-router-dom";
import { CheckCircle2, Circle } from "lucide-react";

export function nextAction(d: any) {
  const r = d.request;
  const cands = d.match?.candidates || [];
  const engaged = cands.filter((c: any) => c.engaged);
  const granted = d.consents.filter((c: any) => c.status === "granted" && c.request_version === r.version);
  const responded = d.introductions.find((i: any) => i.request_version === r.version && i.status !== "pending");
  const steps = [
    ["Job posted", true],
    [`${cands.length} match${cands.length === 1 ? "" : "es"} found`, cands.length > 0],
    ["Vendor engaged", engaged.length > 0],
    ["Details shared", granted.length > 0],
    ["Vendor responded", !!responded],
  ] as [string, boolean][];
  let action: { label: string; to?: string } | null = null;
  if (r.status !== "open") action = null;
  else if (!cands.length) action = { label: "No matches yet — try another trade or area via Edit request" };
  else if (!engaged.length) action = { label: "Review your matches", to: "#matches-h" };
  else if (!granted.length) action = { label: `Share details with ${engaged[0].vendor_name}`, to: `/customer/requests/${r.id}/candidates/${engaged[0].candidate_id}` };
  else if (!responded) action = { label: "Waiting for the vendor to respond" };
  else action = { label: responded.status === "accepted" ? "Vendor accepted — expect contact" : "Vendor declined — choose another match", to: responded.status === "accepted" ? undefined : "#matches-h" };
  return { steps, action };
}

export function RequestTimeline({ d }: { d: any }) {
  const { steps, action } = nextAction(d);
  const closed = d.request.status !== "open";
  return (
    <>
      <ol className="mb-6 flex flex-wrap gap-x-4 gap-y-2 rounded-lg border border-[var(--steel)] bg-white p-3 text-sm" aria-label="Request progress" data-testid="request-timeline">
        {steps.map(([label, done], i) => (
          <li key={i} className={`flex items-center gap-1 ${done ? "font-semibold text-[var(--navy)]" : "text-[var(--muted)]"}`} data-testid={`timeline-step-${i}`}>
            {done ? <CheckCircle2 className="h-4 w-4 text-[var(--blue)]" aria-hidden /> : <Circle className="h-4 w-4" aria-hidden />}{label}<span className="sr-only">{done ? " (done)" : " (not yet)"}</span>
          </li>
        ))}
        {closed && <li className="font-semibold text-[var(--red)]" data-testid="timeline-closed">Request {d.request.status}</li>}
      </ol>
      {action && (
        <div className="fixed inset-x-0 bottom-0 z-30 border-t border-[var(--steel)] bg-white p-3 shadow-[0_-4px_12px_rgba(0,0,0,.08)] lg:static lg:mb-6 lg:rounded-lg lg:border lg:shadow-none" data-testid="request-next-action">
          {action.to?.startsWith("/") ? <Link to={action.to} className="btn btn-primary w-full lg:w-auto">{action.label}</Link>
            : action.to ? <a href={action.to} className="btn btn-primary w-full lg:w-auto">{action.label}</a>
              : <p className="text-center text-sm font-semibold lg:text-left">{action.label}</p>}
        </div>
      )}
    </>
  );
}
